module.exports = __webpack_public_path__ + "static/media/week-measurements-250.e763b32f.svg";